import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../store";
import {
  fetchMe,
  loadingUser,
  startInitializing,
} from "../store/slices/authSlice";
import { fetchWarehouseLocations } from "../store/slices/warehouseSlice";
import { tokenStorage } from "../utils/storage";

export default function useAuthInit() {
  const dispatch = useDispatch<AppDispatch>();
  const { userInfo } = useSelector((state: RootState) => state.auth);
  const { locations } = useSelector((state: RootState) => state.warehouse);
  const hasAttemptedFetch = useRef(false);

  useEffect(() => {
    const initAuth = async () => {
      const token = tokenStorage.get();
      if (token) {
        dispatch(loadingUser());
        if (!userInfo) {
          dispatch(startInitializing());
          await dispatch(fetchMe());
        }

        if (
          !hasAttemptedFetch.current &&
          (!locations || locations.length === 0)
        ) {
          hasAttemptedFetch.current = true;
          await dispatch(fetchWarehouseLocations());
        }
      }
    };
    initAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, userInfo]);
}
